<template>
    <!-- 포인트 팝업 -->
    <div class="pop-Npoint" style="display:none;">
        <div class="inner">
            <div class="icon"><img src="/images/img/img-nicon.png" alt="N아이콘"></div>
            <div class="con-1">
                <p>축하합니다!</p>
                <p>N포인트가 <strong>적립</strong>되었습니다.</p>
                <p><strong>{{n_point}}<span>P</span></strong></p>
            </div>
            <div class="con-2">
                <p>[{{point_name}}]</p>
                <p>지역문화이야기 / {{story_title}}</p>
            </div>
            <div class="con-3">
                <p>현재까지 적립된<br><strong>N포인트</strong></p>
                <p><a :href="portalMyUrl" target="_blank">{{tot_point}}<span>p</span><img src="/images/btn/btn-npoint-poparr.png" alt="화살표"></a></p>
            </div>
            <button type="button" class="Npoint-close" @click="closeSelf"><img src="/images/btn/btn-npoint-close.png" alt="닫기 아이콘"></button>
        </div>
        <div class="text-center color-gray" style="position:absolute; top:12%; padding-top:100px; height: 89%; width:100%; background-color: #EEEEEE; opacity: 0.8;" v-show="isLoading">
            <div id="progress-wrapper">
                <div class="profile-main-loader">
                    <div class="loader">
                        <svg class="circular-loader" viewBox="25 25 50 50" >
                            <circle class="loader-path" cx="50" cy="50" r="20" fill="none" stroke="#00a2ec" stroke-width="2" />
                        </svg>
                    </div>
                </div>
            </div>
            로딩중입니다.
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: String,
            type: String,
            title: String
        },
        data(){
            return {
                pointId: '',
                story_id: '',
                story_title: '',
                portalMyUrl: '',
                point_name: 'N스탬프를 찾아라',
                n_point: 0,
                tot_point: 0,
                isLoading: true,
            }
        },
        created(){
            // 전역 이벤트 감지
            this.$bus.$on('open-point-modal-popup', this.openPointModalPopup); // 팝업 보이기
        },
        methods: {
            openPointModalPopup(pointId){
                $(".pop-Npoint").fadeIn();
                this.story_id = this.id;
                this.story_title = this.title;
                this.pointId = pointId;
                this.getPointInfo();
            },
            closeSelf() {
                $('.pop-Npoint').fadeOut();
                $('.Npoint-btn').fadeOut();
            },
            getPointInfo() {
                axios.get('/api/v1/helper/userpointinfo', {
                    params: {
                        story_id: this.story_id,
                        story_title: this.story_title,
                        point_id: this.pointId
                    }
                }).then(({data}) => {
                    if (data.resultCode == '00') {
                        this.point_name = data.nPointName;
                        this.n_point = data.nPoint;
                        this.tot_point = data.totPoint;
                        this.portalMyUrl = data.portal_url;
                        this.isLoading = false;
                    } else {
                        alert(data.resultMsg);
                        this.closeSelf();
                    }
                }).catch(err => {
                    console.log(err.response);
                });
            }
        }
    }
</script>